import {Link} from "react-router-dom";
import {useEffect, useState} from "react";
import VideoSource from "./VideoSource";

const VideoCardDetails = ({props}) => {
    const {name, btnText, url, video} = props;
    const [text, setText] = useState(btnText);
    const errText = "this project does not have " + btnText + " or is in the making"
    useEffect(() => {
        if (!url) {
            setText(errText)
        }
    }, [name, url]);

    return (
        <Link to={url === "" ? "/error" : url}
            target="_blank"
              className={`${url === "" ? "disabled-link" : ""} video__card flex end relative hover__card block`}
              style={{gridArea: name ? name : ""}}
        >
            <VideoSource path={video} name={name} text={text} className="about__video" width={[320,480,720]}/>
        </Link>
    )
}
export default VideoCardDetails